'use client';

import {
  SKILL_EXAM_COMMON_LIST,
  SKILL_EXAM_SUMMARY,
} from '@/data/exam/exam.data';
import ExamGuideList from '../components/exam-guide-list';
import ExamGuideSummary from '../components/exam-guide-summary';

export default function Client() {
  return (
    <>
      <ExamGuideSummary items={SKILL_EXAM_SUMMARY} />
      <ExamGuideList items={SKILL_EXAM_COMMON_LIST} />
    </>
  );
}
